import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as ApplicantService from '../../../services/api/applicant';

interface FetchApplicantsListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
}

class FetchApplicants implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_APPLICANTS,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_APPLICANTS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_APPLICANTS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: FetchApplicantsListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await ApplicantService.fetchApplicants(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchApplicants Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IResendVerificationLinkInput {
  applicant_id: number;
}
class ResendVerificationLink implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.RESEND_VERIFICATION_LINK,
      status: StateStatus.Pending,
      data: null,
    };
  }
  onSuccess(): IAction {
    return {
      type: Types.RESEND_VERIFICATION_LINK,
      status: StateStatus.Success,
      data: null,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.RESEND_VERIFICATION_LINK,
      status: StateStatus.Failed,
      data: null,
    };
  }

  action(payload: IResendVerificationLinkInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        await ApplicantService.resendVerificationLink(payload);
        dispatch(this.onSuccess());
      } catch (error: any) {
        // console.log('ResendVerificationLink Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchApplicantsAction: (payload: FetchApplicantsListInput) =>
    new FetchApplicants().action(payload),
  resendVerificationLinkAction: (payload: IResendVerificationLinkInput) =>
    new ResendVerificationLink().action(payload),
};
